import React, { useEffect, useState } from "react";
import DataTable from "../Components/DataTable";
import useInput from "../Hooks/useInput";
import usePostData from "../Hooks/usePostData";
import useDelete from "../Hooks/useDelete";
import Input, { Label } from "../Components/Input";
import Select from "react-select";
import useGetData from "../Hooks/useGetData";

const Approvers = () => {
    const [Editing, setEditing] = useState(false);
    const initialState = {
        moduleId: null,
        usersId: null,
        departmentId: null,
        approvalLevel: "",
        approverTitle: ""
    };
    const url = "api/Approvers/";
    const [state, FetchAll] = useGetData(url);
    const { HandleDelete, HandleEditData } = useDelete(url);
    const {
        values,
        HandleChange,
        reset,
        FillData,
        handleSelectChange,
        selectOptions
    } = useInput(initialState);

    useEffect(() => {
        FetchAll();
    }, []);

    let TableHeader = [
        "Module",
        "Approver",
        "Department",
        "Approval Level",
        "Approver Title",
        "Action"

    ];
    let rowData = [
        "module.name",
        "approver.email",
        "department.name",
        "approvalLevel",
        "approverTitle"

    ];

    const handleEdit = k => {
        const data = {
            moduleId: k.moduleId,
            usersId: k.usersId,
            departmentId: k.departmentId,
            approvalLevel: k.approvalLevel,
            approverTitle: k.approverTitle

        };
        FillData(data, {
            usersId: {
                value: k.usersId || "",
                label: (k.approver || "").email || ""
            },
            moduleId: {
                value: k.moduleId || "",
                label: (k.module || "").name || ""
            },
            departmentId: {
                value: k.departmentId || "",
                label: (k.department || "").name || ""
            },
        });
        setEditing(true);
    };
    const handleDelete = k => {
        HandleDelete(k);
    };
    const HandleSubmit = e => {
        e.preventDefault();
        usePostData(url, values);

        reset();
    };
    const HandleUpdate = e => {
        e.preventDefault();
        HandleEditData(values);
        reset();
    };
    const HandleOnClose = e => {
        e.preventDefault();
        setEditing(false);
        reset();
    };
    return (
        <div>
            {state.IsLoading ? (
                <div id="page-loader" className="fade show"><span className="spinner"></span></div>
            ) : (
                    <DataTable
                        page={"Approvers"}
                        data={state.data}
                        HandleOnClose={HandleOnClose}
                        handleEdit={e => handleEdit(e)}
                        handleDelete={e => handleDelete(e)}
                        rowData={rowData}
                        TableHeader={TableHeader}
                    >
                        <ApproversForm
                            values={values}
                            selectOptions={selectOptions}
                            IsEditing={Editing}
                            HandleUpdate={HandleUpdate}
                            HandleOnClose={HandleOnClose}
                            HandleSubmit={HandleSubmit}
                            handleSelectChange={handleSelectChange}
                            HandleChange={HandleChange}
                        />
                    </DataTable>
                )}
        </div>
    );
};

export default Approvers;

const ApproversForm = props => {
    const [Users, Fetch] = useGetData("api/account");
    const [Modules, FetchModules] = useGetData("api/usercode/category/module");
    const [Department, FetchDepartment] = useGetData("api/department");

    const UserOptions = Users.data.map((k, i) => {
        return {
            value: k.id.toString(),
            label: k.email.toString()
        };
    });
    const ModuleOptions = Modules.data.map((k, i) => {
        return {
            value: k.id.toString(),
            label: k.name.toString()
        };
    });
    const DepartmentOptions = Department.data.map((k, i) => {
        return {
            value: k.id.toString(),
            label: k.name.toString()
        };
    });
    useEffect(() => {
        Fetch();
        FetchDepartment();
        FetchModules();
    }, []);

    return (
        <div>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-10 md-offset-2">
                        <div className="form-group row m-b-10">
                            <Label label="Module" isRequired={true} />
                            <div className="col-md-6">
                                <Select
                                    name="moduleId"
                                    className="form-group"
                                    defaultInputValue={props.selectOptions.moduleId}
                                    value={props.selectOptions.moduleId}
                                    onChange={props.handleSelectChange}
                                    options={ModuleOptions}
                                />
                            </div>
                        </div>
                        <div className="form-group row m-b-10">
                            <Label label="Department" isRequired={true} />
                            <div className="col-md-6">
                                <Select
                                    name="departmentId"
                                    className="form-group"
                                    defaultInputValue={props.selectOptions.departmentId}
                                    value={props.selectOptions.departmentId}
                                    onChange={props.handleSelectChange}
                                    options={DepartmentOptions}
                                />
                            </div>
                        </div>
                        <div className="form-group row m-b-10">
                            <Label label="Approver" isRequired={true} />
                            <div className="col-md-6">
                                <Select
                                    name="usersId"
                                    className="form-group"
                                    defaultInputValue={props.selectOptions.usersId}
                                    value={props.selectOptions.usersId}
                                    onChange={props.handleSelectChange}
                                    options={UserOptions}
                                />
                            </div>
                        </div>
                        <div className="form-group row m-b-10">
                            <Label label="Approval Level" isRequired={true} />
                            <div className="col-md-6">
                                <Input
                                    name="approvalLevel"
                                    value={props.values.approvalLevel}
                                    HandleChange={props.HandleChange}
                                />
                            </div>
                        </div>
                        <div className="form-group row m-b-10">
                            <Label label="Approver Title" isRequired={true} />
                            <div className="col-md-6">
                                <Input
                                    name="approverTitle"
                                    value={props.values.approverTitle}
                                    HandleChange={props.HandleChange}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <a
                    className="btn btn-white"
                    data-dismiss="modal"
                    onClick={props.HandleOnClose}
                >
                    Close
        </a>
                {props.IsEditing ? (
                    <button
                        type="submit"
                        onClick={props.HandleUpdate}
                        className="btn btn-primary"
                    >
                        Update
                    </button>
                ) : (
                        <button
                            type="submit"
                            onClick={props.HandleSubmit}
                            className="btn btn-primary"
                        >
                            Save
                        </button>
                    )}
            </div>
        </div>
    );
};
